import { ConsentClient } from './ConsentClient';

export interface IConsentConfiguration {
    consentEndpoint: string
    appName: string
    termsAndConditionsTextId: string
    privacyStatementTextId: string
    countryCode: string
    language: string
}

export interface ILatestVersion {
    majorVersion: number
    minorVersion: number
}

export class ConsentService {
    public constructor(private readonly consentConfiguration: IConsentConfiguration, private readonly client: ConsentClient) {
    }

    public getTermsAndConditionsTextPdfUrl(version: ILatestVersion): string {
        return `${this.consentConfiguration.consentEndpoint}/consent/v1/texts/${this.consentConfiguration.appName}/${this.consentConfiguration.countryCode}/${this.consentConfiguration.language}/${this.consentConfiguration.termsAndConditionsTextId}/${version.majorVersion}.${version.minorVersion}/pdf`;
    }

    public getPrivacyStatementTextPdfUrl(): string {
        return `${this.consentConfiguration.consentEndpoint}/consent/v1/texts/${this.consentConfiguration.appName}/${this.consentConfiguration.countryCode}/${this.consentConfiguration.language}/${this.consentConfiguration.privacyStatementTextId}/latest/pdf`;
    }

    public async acceptTermsAndConditions(majorVersion: number, isWcar: boolean): Promise<boolean> {
        try {
            await this.client.storeConsentForMajorVersion(majorVersion, isWcar);
            return true;
        } catch {
            return false;
        }
    }

    public async getLatestVersion(isWcar: boolean): Promise<ILatestVersion> {
        return this.client.getLatestVersion(isWcar);
    }

    public async setVehicleSpecificConsentIfNeeded(vin: string, isWcar: boolean): Promise<void> {
        const consentResponse = await this.client.getVehicleSpecificConsent(vin, isWcar);
        if (!consentResponse.consentsGiven) {
            await this.client.storeVehicleSpecificConsent(vin, isWcar);
        }
    }
}